import { createLucideIcon } from 'lucide-react';
export const SearchIcon = createLucideIcon('search', [
  [
    'path',
    {
      d: 'M17.9497 4.90381C15.2161 2.3654 10.7839 2.3654 8.05025 4.90381C5.31658 7.44221 5.31658 11.5578 8.05025 14.0962C10.7839 16.6346 15.2161 16.6346 17.9497 14.0962C20.6834 11.5578 20.6834 7.44221 17.9497 4.90381Z',
      key: 'vcdhwv',
    },
  ],
  [
    'path',
    {
      d: 'M3 21L9 15',
      key: '1igyx3',
    },
  ],
]);
